import { render, staticRenderFns } from "./ActiveRanking.vue?vue&type=template&id=1192c59c"
import script from "./ActiveRanking.vue?vue&type=script&lang=js"
export * from "./ActiveRanking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports